import { render, staticRenderFns } from "./SignalTokenTransfer.vue?vue&type=template&id=2157b134&scoped=true&"
import script from "./SignalTokenTransfer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenTransfer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157b134",
  null
  
)

export default component.exports